module.exports = {
  "id": "builtin_physics",
  "color": "green",
  "title": "builtin_physics",
  "icon": "bouncify",
  "category": "builtin",
  "description": "Make a piece move and bounce",
  "exposedVariables": [],
  "info": [
    {
      "text": "Turn a piece into a bouncing ball",
      "image": "provision/glitches/builtin_physics/builtin_physics.gif"
    }
  ],
  "codeImage": "provision/glitches/builtin_physics/builtin_physics.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/builtin_physics/builtin_physics.svg"
};